import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOrderWithdrawalStatus = {
  name: "getOrderWithdrawalStatus" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    /**
     * True when a withdrawal already exists for this order that has not yet
     * been turned into a return (i.e. its `returnId` is null). Used to block a
     * second withdrawal submission for the same order.
     */
    hasPendingWithdrawal: z.boolean(),
  }),
};
